import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
// import { routerMiddleware } from 'react-router-redux';
import rootEpic from './epics';
import { routerReducer } from 'react-router-redux';
import thunk from 'redux-thunk';
// import createLogger from 'redux-logger';
// import { composeWithDevTools } from "redux-devtools-extension";

import { userReducer } from '../common/user';
import {
  postReducer,
  categoryReducer,
  groupsReducer,
  connHeaderReducer,
  sendEmailsReducer,
  sendWeeklyEmailsReducer,
  emailLogsReducer,
  webLogsReducer,
  placeReducer,
  pageReducer,
  pageTypesReducer,
  subscribedUserReducer,
  queuePDFReducer,
  learningGoalsPDFReducer,
} from './admin';
import {
  settingsReducer,
  dashboardReducer,
  connectionReducer,
  noticeReducer,
  calendarReducer,
  audienceReducer,
  absencesReducer,
  financialinfoReducer,
  emergencybroadcastReducer,
  yearinfoReducer,
  keyLearningAreaReducer,
  unitsReducer,
  courseTasksReducer,
  courseClassroomsReducer,
  myDayTimetableReducer,
  teacherDayTimetableReducer,
  upcomingTasksReducer,
  parentDashboardReducer,
  studentGoalsReducer,
  schoolPsychologyRequestReducer,
  metricsReducer
} from './portal';

// import { adminReducer } from '../views/admin'
// import { connectionsReducer } from '../views/connections';
// import { noticesReducer } from '../views/notices';
// import { articleReducer } from '../views/article'

export const rootReducer = combineReducers({
  settings: settingsReducer,
  dashboard: dashboardReducer,
  posts: postReducer,
  places: placeReducer,
  pages: pageReducer,
  pagetypes: pageTypesReducer,
  keyLearningArea: keyLearningAreaReducer,
  myDayTimetable: myDayTimetableReducer,
  teacherDayTimetable: teacherDayTimetableReducer,
  upcomingTasks: upcomingTasksReducer,
  courseUnits: unitsReducer,
  courseTasks: courseTasksReducer,
  courseClassrooms: courseClassroomsReducer,
  category: categoryReducer,
  groups: groupsReducer,
  connHeader: connHeaderReducer,
  sendEmails: sendEmailsReducer,
  emailLogs: emailLogsReducer,
  sendWeeklyEmails: sendWeeklyEmailsReducer,
  user: userReducer,
  calendar: calendarReducer,
  audiences: audienceReducer,
  absences: absencesReducer,
  financialInfo: financialinfoReducer,
  yearinfo: yearinfoReducer,
  connections: connectionReducer,
  notices: noticeReducer,
  emergencybroadcast: emergencybroadcastReducer,
  routing: routerReducer,
  weblogs: webLogsReducer,
  subscribedUsers: subscribedUserReducer,
  parentDashboard: parentDashboardReducer,
  studentGoals: studentGoalsReducer,
  schoolPsychologyRequest:schoolPsychologyRequestReducer,
  queuePDF:queuePDFReducer,
  larningGoalsPDF:learningGoalsPDFReducer,
  metrics:metricsReducer,
});

// const logger = createLogger({ collapsed: true });

const epicMiddleware = createEpicMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      epicMiddleware,
      thunk
      // logger,
    )
  )
);

epicMiddleware.run(rootEpic);

export default store;
